import { createApp } from 'vue'
import { pinia } from './pinia.js'
import router from './router.js'
import App from './App.vue'
import './assets/style.scss'

const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')
